<!--
 * @Author: 戴东宇
 * @Date: 2021-12-20 14:44:59
 * @LastEditTime: 2026-02-03 13:00:53
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/Register/index.vue
-->
<template>
  <div class="app">
    <div class="registerBox">
      <div class="rightBox">
        <!-- <div class="Tips" style="margin-bottom:4px;">必填信息</div> -->
        <div class="Requirement">
          <div class="letRe fl">姓名</div>
          <input
            class="rigRe fr"
            type="text"
            placeholder="请输入姓名"
            v-model="name"
            @focus="focus"
            @blur="blur"
          />
        </div>
        <div class="Requirement" v-show="showBirthday">
          <div class="letRe fl">生日</div>
          <input
            class="rigRe fr"
            type="text"
            placeholder="请选择生日"
            v-model="birthday"
            @focus="openCalendar"
            readonly
          />
        </div>
        <!-- 日历选择器弹窗 -->
        <div
          class="calendar-overlay"
          v-show="showCalendar"
          @click="closeCalendar"
        ></div>
        <div class="calendar-modal" v-show="showCalendar">
          <div class="calendar-header">
            <div class="calendar-controls">
              <span class="month-year" @click="showYearPicker = true">
                {{ currentYear }}年{{ currentMonth }}月
              </span>
            </div>
          </div>
          <!-- 年份选择器 -->
          <div class="year-picker" v-show="showYearPicker">
            <!-- <div class="picker-header-title">选择年份</div> -->
            <div class="year-grid">
              <div
                v-for="year in yearList"
                :key="year"
                class="year-item"
                :class="{ active: year === currentYear }"
                @click="selectYear(year)"
              >
                {{ year }}
              </div>
            </div>
          </div>
          <!-- 月份选择器 -->
          <div class="month-picker" v-show="showMonthPicker">
            <!-- <div class="picker-header-title">选择月份</div> -->
            <div class="month-grid">
              <div
                v-for="month in 12"
                :key="month"
                class="month-item"
                :class="{ active: month === currentMonth }"
                @click="selectMonth(month)"
              >
                {{ month }}
              </div>
            </div>
          </div>
          <div
            class="calendar-weekdays"
            v-show="!showYearPicker && !showMonthPicker"
          >
            <div class="weekday">日</div>
            <div class="weekday">一</div>
            <div class="weekday">二</div>
            <div class="weekday">三</div>
            <div class="weekday">四</div>
            <div class="weekday">五</div>
            <div class="weekday">六</div>
          </div>
          <div
            class="calendar-days"
            v-show="!showYearPicker && !showMonthPicker"
          >
            <div
              v-for="day in calendarDays"
              :key="day.date"
              class="day"
              :class="{
                'other-month': !day.isCurrentMonth,
                selected: day.isSelected,
                today: day.isToday,
              }"
              @click="selectDate(day)"
            >
              {{ day.day }}
            </div>
          </div>
          <div class="calendar-footer">
            <button @click="closeCalendar" class="btn-cancel">取消</button>
            <button @click="confirmDate" class="btn-confirm">确定</button>
          </div>
        </div>
        <div class="Requirement">
          <div class="letRe fl">电话</div>
          <input
            class="rigRe fr"
            type="number"
            placeholder="请输入电话号码"
            pattern="[0-9]*"
            v-model="tel"
            @focus="focus"
            @blur="blur"
          />
          <div
            class="vcodeSty"
            @click="clickVcode"
            :class="itemFlase ? '' : 'vcodeStyFa'"
          >
            {{ itemFlase ? '获取验证码' : idx }}
          </div>
        </div>
        <div class="Requirement">
          <div class="letRe fl">验证码</div>
          <input
            class="rigRe fr"
            type="number"
            placeholder="请输入验证码"
            pattern="\d*"
            v-model="vcode"
            @focus="focus"
            @blur="blur"
            @input="handleChange($event)"
          />
        </div>
        <div class="Tips_text" style="margin-bottom: 4px; border: none">
          <i class="gantan">!</i
          >若需要在小程序端使用电子会员，绑定手机号需要与微信绑定手机号一致!
        </div>
        <div
          class="Determine"
          :class="disabled === true ? 'dis' : ''"
          @click="disabled === true ? '' : clickApply()"
        >
          注册
        </div>
      </div>
    </div>
    <!-- <Promptbox v-if="prom" :message="Tips"></Promptbox> -->
    <loading v-if="load"></loading>
    <div class="toast" v-show="toast">{{ toastText }}</div>
    <!-- <div class="returns">
      <Return></Return>
    </div> -->
  </div>
</template>
<script>
export default {
  name: 'Register',
  data() {
    return {
      name: '',
      birthday: '',
      tel: '',
      vcode: '',
      idx: 60,
      itemFlase: true,
      toast: false,
      toastText: '',
      load: false,
      disabled: false,
      showBirthday: false,
      showCalendar: false,
      showYearPicker: false,
      showMonthPicker: false,
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      selectedDate: null,
      yearList: [],
    }
  },
  computed: {
    calendarDays() {
      const year = this.currentYear
      const month = this.currentMonth
      const firstDay = new Date(year, month - 1, 1)
      const lastDay = new Date(year, month, 0)
      const prevLastDay = new Date(year, month - 1, 0)

      const firstDayOfWeek = firstDay.getDay()
      const lastDateOfMonth = lastDay.getDate()
      const lastDateOfPrevMonth = prevLastDay.getDate()

      const days = []

      // 上个月的日期
      for (let i = firstDayOfWeek - 1; i >= 0; i--) {
        days.push({
          day: lastDateOfPrevMonth - i,
          date: new Date(year, month - 2, lastDateOfPrevMonth - i),
          isCurrentMonth: false,
          isSelected: false,
          isToday: false,
        })
      }

      // 当前月的日期
      const today = new Date()
      for (let i = 1; i <= lastDateOfMonth; i++) {
        const date = new Date(year, month - 1, i)
        const isToday = date.toDateString() === today.toDateString()
        const isSelected =
          this.selectedDate &&
          date.toDateString() === this.selectedDate.toDateString()

        days.push({
          day: i,
          date: date,
          isCurrentMonth: true,
          isSelected: isSelected,
          isToday: isToday,
        })
      }

      // 下个月的日期
      const remainingDays = 42 - days.length
      for (let i = 1; i <= remainingDays; i++) {
        days.push({
          day: i,
          date: new Date(year, month, i),
          isCurrentMonth: false,
          isSelected: false,
          isToday: false,
        })
      }

      return days
    },
  },
  mounted() {
    this.initYearList()
    this.RequestVIP(`h5/vip/usingBirthDate`, (r) => {
      console.log(r)
      if (r.data.data.usingBirthDate === true) {
        this.showBirthday = true
      } else {
        this.showBirthday = false
      }
    })
  },
  methods: {
    focus() {},
    blur() {},
    initYearList() {
      const currentYear = new Date().getFullYear()
      this.yearList = []
      for (let i = currentYear; i >= 1900; i--) {
        this.yearList.push(i)
      }
    },
    openCalendar() {
      this.showCalendar = true
      this.showYearPicker = true
      this.showMonthPicker = false
      if (this.birthday) {
        const [year, month, day] = this.birthday.split('-')
        this.currentYear = parseInt(year)
        this.currentMonth = parseInt(month)
        this.selectedDate = new Date(
          parseInt(year),
          parseInt(month) - 1,
          parseInt(day)
        )
      } else {
        this.currentYear = new Date().getFullYear()
        this.currentMonth = new Date().getMonth() + 1
        this.selectedDate = null
      }
    },
    selectYear(year) {
      this.currentYear = year
      this.showYearPicker = false
      this.showMonthPicker = true
    },
    selectMonth(month) {
      this.currentMonth = month
      this.showMonthPicker = false
    },
    closeCalendar() {
      this.showCalendar = false
    },
    prevMonth() {
      if (this.currentMonth === 1) {
        this.currentMonth = 12
        this.currentYear -= 1
      } else {
        this.currentMonth -= 1
      }
    },
    nextMonth() {
      if (this.currentMonth === 12) {
        this.currentMonth = 1
        this.currentYear += 1
      } else {
        this.currentMonth += 1
      }
    },
    selectDate(day) {
      if (day.isCurrentMonth) {
        this.selectedDate = day.date
      }
    },
    confirmDate() {
      if (this.selectedDate) {
        const year = this.selectedDate.getFullYear()
        const month = String(this.selectedDate.getMonth() + 1).padStart(2, '0')
        const day = String(this.selectedDate.getDate()).padStart(2, '0')
        this.birthday = `${year}-${month}-${day}`
      }
      this.closeCalendar()
    },
    handleChange(event) {
      if (event.target.value > 6) {
        this.vcode = event.target.value.slice(0, 6)
      }
    },
    clickVcode() {
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!!reg_tel.test(this.tel)) {
        if (this.itemFlase) {
          this.load = true
          this.itemFlase = false
          this.RequestVIP(`/h5/vip/sms?tel=${this.tel}`, (r) => {
            console.log(r)
            if (r.data.code === '20000') {
              this.load = false
              this.toast = true
              this.toastText = '验证码已发送'
              setTimeout(() => {
                this.toast = false
              }, 1000)
              this.idx = 60
              let timer = setInterval(() => {
                this.idx -= 1
                if (this.idx == 0) {
                  this.itemFlase = true
                  clearInterval(timer)
                }
              }, 1000)
            } else {
              this.toast = true
              this.toastText = r.data.msg
              this.load = false
              setTimeout(() => {
                this.toast = false
              }, 1000)
            }
          })
        }
      } else {
        this.toast = true
        this.toastText = '请填写正确的手机号'
        setTimeout(() => {
          this.toast = false
        }, 1000)
      }
    },
    clickApply() {
      // window.location.href = `${window.location.origin}/vip-h5/api/v2/h5/vip?companyID=${companyID}`;
      console.log(this.name, this.tel, this.vcode, this.birthday)
      const companyID = localStorage.getItem('companyID')
      if (!this.name || !this.tel || !this.vcode) {
        this.toast = true
        this.toastText = '请先填写完整信息'
        setTimeout(() => {
          this.toast = false
        }, 1000)
        return
      }
      this.disabled = true
      this.RequestVIP(
        `/h5/vip/sms/check?tel=${this.tel}&code=${this.vcode}`,
        (r) => {
          console.log(r, 'rrrr')
          if (r.data.code === '20000') {
            const code = localStorage.getItem('code')
            this.RequestVIP3(
              `/h5/vip/info/${code}`,
              { username: this.name, tel: this.tel, birthday: this.birthday },
              (res) => {
                this.disabled = false
                if (res.data.code === '20000') {
                  this.toast = true
                  this.toastText = '注册成功！'
                  setTimeout(() => {
                    const baseUrl = window.location.origin

                    this.toast = false
                    if (baseUrl.indexOf('canary') >= 1) {
                      window.location.href = `https://api.cnuri.cn/vip-h5/api/v2/h5/vip?companyID=${companyID}&canary=true`
                    } else if (baseUrl.indexOf('pre') >= 1) {
                      window.location.href = `https://api.cnuri.cn/vip-h5/api/v2/h5/vip?companyID=${companyID}&canary=true&pre=true`
                    } else {
                      window.location.href = `${baseUrl}/vip-h5/api/v2/h5/vip?companyID=${companyID}`
                    }
                  }, 1000)
                } else {
                  this.toast = true
                  this.toastText = res.data.msg
                  setTimeout(() => {
                    this.toast = false
                  }, 1000)
                }
                console.log(res, 'resullllllllllllllll')
              }
            )
          } else {
            this.toast = true
            this.toastText = res.data.msg
            setTimeout(() => {
              this.toast = false
            }, 1000)
          }
        }
      )
    },
  },
}
</script>
<style scoped>
/*! autoprefixer: off */
.app {
  height: 100%;
  width: 100%;
  background: #fff;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.registerBox {
  width: 94%;
  margin-left: 3%;
  background: #fff;
  border-radius: 5px;
  height: 74%;
  padding-top: 10px;
  /* box-shadow: 0px 0px 5px 0px #bdbdbd; */
  position: relative;
}

.rightBox {
  float: right;
  width: 94%;
  height: 100%;
  margin-top: 10px;
}

.rightBox > div {
  border-bottom: 1px solid #e0e0e0;
}

.Tips {
  font-size: 12px;
  color: #757575;
  height: 20px;
  line-height: 20px;
}

.Requirement {
  height: 35px;
  line-height: 35px;
  font-size: 11px;
  color: #212121;
  position: relative;
}

.letRe {
  width: 22%;
  height: 100%;
}

.rigRe {
  display: block;
  height: 100%;
  width: 75%;
  border: none;
  padding: 9px 14px;
  box-sizing: border-box;
  /* border-bottom: 1px solid #e0e0e0; */
  font-size: 11px;
}

input::-webkit-input-placeholder {
  color: #bdbdbd;
  font-size: 11px;
}

input {
  outline: none;
}

.Tips {
  width: 100%;
  height: 20px;
  margin-top: 10px;
  border: none !important;
  font-size: 8px;
}

.Tips_lo {
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  background: #46a1ff;
  margin-top: 4px;
  margin-right: 3%;
  font-size: 8px;
}

.Tips_text {
  color: #757575;
  line-height: 20px;
}

.Determine {
  width: 93%;
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #fff;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  border-radius: 4px;
  font-size: 11px;
  text-decoration: none;
  margin-top: 38%;
}

.vcodeSty {
  height: 19px;
  line-height: 19px;
  position: absolute;
  right: 6px;
  top: 6px;
  width: 46px;
  border: 0.5px solid red;
  color: red;
  font-size: 8px;
  border-radius: 2px;
  text-align: center;
}

.vcodeStyFa {
  border: 0.5px solid #bdbdbd;
  color: #bdbdbd;
}

.toast {
  width: 100px;
  /* height: 30px; */
  line-height: 15px;
  padding: 10px;
  border-radius: 5px;
  background: rgb(49, 47, 47);
  opacity: 0.5;
  color: white;
  position: fixed;
  top: 46%;
  left: 30%;
  text-align: center;
  font-size: 10px;
}

.dis {
  background: gray;
}

.returns {
  position: fixed;
  top: 80%;
  left: 0;
}

.gantan {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  color: #fff;
  font-size: 8px;
  text-align: center;
  line-height: 10px;
}

/* 日历选择器样式 */
.calendar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.calendar-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 1000;
  border-radius: 12px 12px 0 0;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.calendar-header {
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.calendar-title {
  font-size: 16px;
  font-weight: bold;
  color: #212121;
  margin-bottom: 12px;
  text-align: center;
}

.calendar-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.btn-nav {
  background: none;
  border: none;
  font-size: 18px;
  color: #ff5a61;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background 0.2s;
}

.btn-nav:active {
  background: #f5f5f5;
}

.month-year {
  font-size: 14px;
  color: #212121;
  font-weight: 500;
  flex: 1;
  text-align: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.month-year:active {
  background: #f5f5f5;
}

/* 年月逐步选择器 */
.year-picker,
.month-picker {
  padding: 12px 8px;
  border-bottom: 1px solid #e0e0e0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.picker-header-title {
  font-size: 13px;
  color: #212121;
  font-weight: 500;
  margin-bottom: 12px;
  text-align: center;
}

.year-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.year-item {
  padding: 8px 4px;
  text-align: center;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.year-item.active {
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  color: #fff;
  border-color: #ff5a61;
}

.year-item:active {
  background: #f5f5f5;
}

.month-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.month-item {
  padding: 8px 4px;
  text-align: center;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.month-item.active {
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  color: #fff;
  border-color: #ff5a61;
}

.month-item:active {
  background: #f5f5f5;
}

.calendar-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
  padding: 12px 8px;
  background: #f9f9f9;
  border-bottom: 1px solid #e0e0e0;
}

.weekday {
  text-align: center;
  font-size: 12px;
  color: #999;
  font-weight: 500;
  padding: 8px 0;
}

.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
  padding: 8px;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.day {
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #212121;
  cursor: pointer;
  border-radius: 4px;
  margin: 4px;
  transition: all 0.2s;
  user-select: none;
}

.day.other-month {
  color: #ccc;
  cursor: not-allowed;
}

.day.today {
  background: #fff3e0;
  color: #ff9c60;
  font-weight: bold;
}

.day.selected {
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  color: #fff;
  font-weight: bold;
}

.day:not(.other-month):active {
  background: #f0f0f0;
}

.calendar-footer {
  display: flex;
  gap: 12px;
  padding: 16px;
  border-top: 1px solid #e0e0e0;
  background: #fff;
}

.btn-cancel,
.btn-confirm {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel {
  background: #f5f5f5;
  color: #666;
}

.btn-cancel:active {
  background: #e0e0e0;
}

.btn-confirm {
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  color: #fff;
}

.btn-confirm:active {
  opacity: 0.9;
}

/*! autoprefixer: on */
</style>



// WEBPACK FOOTER //
// src/Registers/index.vue